import React from "react";
import { ReactComponent as RightDirection } from "icons/right-direction.svg";
import { useNavigate } from "react-router-dom";
import cookie from "react-cookies";
import { toast } from "react-toastify";

const mainSearch = ["FOOD", "HEALTH", "SLEEP", "LEGAL", "EDUCATION"];

const MenuDesktop = () => {
  const navigate = useNavigate();
  return (
    <nav className="flex  gap-x-[20px] gap-y-[12px] sm:flex-wrap sm:justify-center">
      {mainSearch.map((search, index) => (
        <span
          className="flex items-center gap-[4px] font-opensans text-xl text-background cursor-pointer hover:text-[#f2f2f2]"
          key={index}
          onClick={() => {
            if (cookie.load("user").organization !== "Gyde") {
              toast.warning("You are not in Gyde Organization.");
              return;
            }
            navigate(`/search/${search.toLowerCase()}`);
          }}
        >
          {search}
          <RightDirection />
        </span>
      ))}
    </nav>
  );
};

export default MenuDesktop;
